<link rel="stylesheet" type="text/css" href="/assets/css/site.css" />

<div class="layout-wrapper">
  <div id="layout-topbar">
    <a href="#" class="logo" [routerLink]="['/']">
      <img alt="logo" *ngIf="logo" src="data:image/jpeg;base64,{{logo}}"/>
    </a>
    
    <a *ngIf="isLoggedIn" class="logo">
        <label i18n="@@labelText19">
          Olá
        </label>        
        {{cliente.nomeTitular}}
    </a>

    <ul class="topbar-menu">
      <li class="topbar-menu-themes">
        <a  *ngIf="isLoggedIn">
          <label i18n="@@labelText13">MENU</label>
        </a>
        <ul>
          <li>
            <a  *ngIf="isLoggedIn" [routerLink]="['/criarOS']">
              <span class="topbar-submenu-icon fas fa-plus-circle"></span>
              <label i18n="@@labelText14">Novo Atendimento</label>
            </a>
          </li>
          <li>
            <a *ngIf="isLoggedIn" [routerLink]="['/listaOrdemServico']">
              <span class="topbar-submenu-icon fas fa-list-ul"></span>
              <label i18n="@@labelText15">Atendimentos em Aberto</label>
            </a>
          </li>
          <li>
            <a *ngIf="isLoggedIn" [routerLink]="['/listaOsEncerrada']">
              <span class="topbar-submenu-icon fas fa-list-ul"></span>
              <label i18n="@@labelText16">Atendimentos Encerrados</label>
            </a>
          </li>
          <li>
            <a *ngIf="isLoggedIn" [routerLink]="['/editarCliente']">
              <span class="topbar-submenu-icon fas fa-pencil-alt"></span>
              <label i18n="@@labelText75">Editar Dados do Usuário</label>
            </a>
          </li>
          <li>
            <hr />
          <li>
            <a *ngIf="isLoggedIn" [routerLink]="['/login']" (click)="doLogout()">
              <label i18n="@@labelText17">SAIR</label>
            </a>
          </li>
        </ul>
      </li>
     </ul>
  </div>
</div>

